import Common from '../common.vue'
import { registerModule } from '@/app/app.store'


export default {
    path: '/',
    component: Common,
    children: [
        {
            name: 'search',
            path: 'search',
            component: () => import('./search.vue'),
            beforeEnter: (to: any, from: any, next: () => void) => {
                import('./search-service').then(({ SEARCH_STORE }) => {
                    if (SEARCH_STORE) registerModule(to, SEARCH_STORE)
                    next()
                })
            }
        },
        {
            name: 'searchRes',
            path: 'search-result',
            component: () => import('./search-result.vue'),
            beforeEnter: (to: any, from: any, next: () => void) => {
                import('./search-service').then(({ SEARCHRES_STORE }) => {
                    if (SEARCHRES_STORE) registerModule(to, SEARCHRES_STORE)
                    next()
                })
            }
        },
        {
            name: 'searchYuer',
            path: 'search-yuer',
            component: () => import('./search-yuer.vue'),
            beforeEnter: (to: any, from: any, next: () => void) => {
                import('./search-service').then(({ SEARCHRES_STORE }) => {
                    if (SEARCHRES_STORE) registerModule(to, SEARCHRES_STORE)
                    next()
                })
            }
        }
    ]
}
